import React, { memo, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'
import { DialogButtonProps } from './DialogButton.types'

const DialogButton = ({
    text,
    variant = 'close',
    path,
    href,
    disabled,
    onClick,
}: DialogButtonProps) => {
    const buttonVariant = useMemo<'contained' | 'outlined' | 'text'>(
        () =>
            variant === 'left'
                ? 'text'
                : variant === 'close'
                ? 'outlined'
                : 'contained',
        [variant]
    )
    const buttonColor = useMemo<string>(() => {
        switch (variant) {
            case 'close':
                return 'inherit'
            case 'left':
                return 'secondary'
            default:
                return variant
        }
    }, [variant])
    const properties = useMemo<any>(() => {
        if (onClick) {
            return {
                onClick: onClick,
            }
        }

        if (href) {
            return {
                component: 'a',
                href: href,
                target: '_blank',
                rel: 'noopener noreferrer',
            }
        }

        return {
            component: Link,
            to: path ?? '#',
        }
    }, [onClick, path, href])

    return (
        <Button
            variant={buttonVariant}
            size="medium"
            color={buttonColor}
            disabled={disabled}
            {...properties}
        >
            {text}
        </Button>
    )
}

export default memo(DialogButton)
